/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderCopyCargoBySeparate } from './order_copy_cargo_by_separate'
import type { OrderCopyCargoByTotal } from './order_copy_cargo_by_total'
/**
 * Информация о грузе
 */
export type OrderCopyCargoInfo = {
  /**
   * Способ указания информации о грузе
   */
  type: OrderCopyCargoInfo.type
  /**
   * Информация о грузе в виде отдельных грузомест
   */
  separate: null | Array<OrderCopyCargoBySeparate>
  /**
   * Информация о грузе в виде общего веса и объема
   */
  total: null | OrderCopyCargoByTotal
}
export namespace OrderCopyCargoInfo {
  /**
   * Способ указания информации о грузе
   */
  export enum type {
    SEPARATE = 'separate',
    TOTAL = 'total'
  }
}
